// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._6fIUVLSYx{display:flex;margin:20px}._51yqUzxjx{display:flex}._45BgcDDox{margin-right:4px}._36pIMGUyx{color:#006fc8;font-size:12px;margin-left:auto;display:flex;flex-direction:row}._36pIMGUyx a{text-decoration:none;color:#006fc8;margin:0 7px}._36pIMGUyx a:first-child{margin-left:0}._36pIMGUyx a::visited{color:#006fc8;cursor:pointer}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"footer": "_6fIUVLSYx",
	"powered-by-container": "_51yqUzxjx",
	"poweredByContainer": "_51yqUzxjx",
	"powered-by": "_45BgcDDox",
	"poweredBy": "_45BgcDDox",
	"help": "_36pIMGUyx"
};
module.exports = exports;
